export const getCurrentPageCanonicalUrl = (location = window.location) => {
  const pathname = location.pathname.replace(/\/+$/, '')
  return `${location.origin}${pathname || '/'}`
}
